import { Video, PhoneOff } from "lucide-react";

// Embedded Jitsi room — no API keys needed. Both doctor and patient join the same room.
export default function VideoCall({ room, name, onClose }) {
  if (!room) return null;
  const src =
    `https://meet.jit.si/${encodeURIComponent(room)}` +
    `#userInfo.displayName=%22${encodeURIComponent(name || "Guest")}%22` +
    `&config.prejoinPageEnabled=false`;
  return (
    <div className="fixed inset-0 z-[300] bg-black flex flex-col" data-testid="video-call">
      <div className="flex items-center justify-between px-4 py-2 bg-slate-900 text-white">
        <div className="flex items-center gap-2">
          <Video className="w-4 h-4 text-emerald-400" />
          <span className="text-sm font-semibold" data-notranslate>MDvia Care — Teleconsultation</span>
        </div>
        <button data-testid="end-call-btn" onClick={onClose}
          className="inline-flex items-center gap-1.5 text-sm bg-red-600 hover:bg-red-700 px-3 py-1.5 rounded-lg">
          <PhoneOff className="w-4 h-4" /> Leave call
        </button>
      </div>
      <iframe
        title="teleconsult"
        src={src}
        className="flex-1 w-full border-0"
        allow="camera; microphone; fullscreen; display-capture; autoplay; clipboard-write"
      />
    </div>
  );
}
